import {
	AppIdentConfig,
} from '@config/appIdentConfigs';

export const getOrganization = (meInfo: any, appConfig: AppIdentConfig) => {
	if (!meInfo) return undefined;

	// Use app-specific organization extraction
	return appConfig.extractOrganization!(meInfo);
};
